import { useEffect } from "react";

import {
  DesignOption,
  DesktopViewOption,
  DisplayPositionOption,
  IframeState,
} from "@/v2/types";
import { MESSAGE_TYPE, SOURCE_IFRAME } from "@/v2/utils/constants";

// 親サイトに実行可能な操作
export interface FrameControl {
  location?: string;
}

export interface FrameState {
  control?: FrameControl;
  frameView?: DesktopViewOption;
  type?: MESSAGE_TYPE;
  timestamp?: number;
  iframeState?: IframeState;
  displayPosition?: DisplayPositionOption;
  designOption?: DesignOption;
  lastIframeStateData?: boolean;
}

export const sendFrameState = (frameState?: FrameState) => {
  if (!frameState) {
    return;
  }

  try {
    window.parent.postMessage(
      {
        source: SOURCE_IFRAME,
        ...frameState,
      },
      "*",
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("sendFrameState: Cannot send frame state:", error);
  }
};

// 親サイトに送信する
export const useFrameControl = (frameState?: FrameState) => {
  useEffect(() => {
    sendFrameState(frameState);
  }, [frameState]);

  return () => {}; // Return empty function for consistency
};
